import withInteractor from "./ResetSent.interactor";
import withPresenter from "./ResetSent.presenter";
import ResetSentBlockView from "./ResetSent.view";

const ResetSentBlock = withInteractor(withPresenter(ResetSentBlockView));
export default ResetSentBlock;
